"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOpen = exports.getOverlayProps = exports.defaultStateSelector = void 0;
var _getProperty = _interopRequireDefault(require("./getProperty"));
var defaultStateSelector = function defaultStateSelector(state) {
  return (0, _getProperty.default)(state, ['formOverlay']);
};
exports.defaultStateSelector = defaultStateSelector;
var getOverlayProps = function getOverlayProps(form) {
  var getFormOverlayState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStateSelector;
  return function (state) {
    return (0, _getProperty.default)(getFormOverlayState(state), [form], {});
  };
};
exports.getOverlayProps = getOverlayProps;
var isOpen = function isOpen(form) {
  var getFormOverlayState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStateSelector;
  return function (state) {
    return (0, _getProperty.default)(getFormOverlayState(state), [form, 'isOpen'], false);
  };
};
exports.isOpen = isOpen;